






import { Component } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import progressEventBus from '@ustra/nuxt/src/vue/event-bus/global/progress-event-bus'

@Component({})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  // #region variables
  show: boolean = false
  // #endregion
  // #region hooks
  mounted() {
    progressEventBus.on((state) => {
      this.show = state.show
    })
  }
  // #endregion
  // #region methods
  // #endregion
  // #region watches
  // #endregion
}
